import React from 'react';
import { formatNumber } from '../../../utils/formatters';
import './IncomeBreakdown.css';

const IncomeBreakdown = ({ data, incomeData, loading }) => {
  if (loading) {
    return (
      <div className="income-breakdown">
        <div className="income-breakdown-loading">Loading...</div>
      </div>
    );
  }

  const items = [
    { 
      label: 'ROI Income:',
      available: data?.availableROI ||  '0', 
      total: incomeData?.totalROI || '0',
      color: 'cyan', 
      icon: '📈' 
    },
    { 
      label: 'Binary Income:', 
      available: data?.availableBinary || '0', 
      total: incomeData?.totalBinary || '0',
      color: 'purple', 
      icon: '⚡' 
    },
    { 
      label: 'Referral Income:', 
      available: data?.availableReferral || '0', 
      total: incomeData?.totalReferral || '0',
      color: 'pink', 
      icon: '👥' 
    }
  ];

  const totalAvailable = parseFloat(data?.totalAvailable || 0);
  const totalEarned = parseFloat(incomeData?.totalIncome || 0);

  return (
    <div className="income-breakdown">
      <div className="income-breakdown-header">
        <div className="income-header-item">
          <span className="income-header-label">Available</span>
          <span className="income-header-value">{formatNumber(totalAvailable)} USDT</span>
        </div>
        <div className="income-header-divider"></div>
        <div className="income-header-item">
          <span className="income-header-label">Total Earned</span>
          <span className="income-header-value total">{formatNumber(totalEarned)} USDT</span>
        </div>
      </div>
      
      <div className="income-bars">
        {items.map((item, idx) => {
          const available = parseFloat(item.available);
          const total = parseFloat(item.total);
          const percentage = totalAvailable > 0 ? (available / totalAvailable) * 100 : 0;
          
          return (
            <div key={idx} className="income-item">
              <div className="income-item-header">
                <div className="income-item-left">
                  <span className="income-item-icon">{item.icon}</span>
                  <span className="income-item-label">{item.label}&nbsp;</span>
                </div>
                <div className="income-item-values">
                  <span className={`income-item-available text-${item.color}`}>
                    {formatNumber(available)}
                  </span>
                  <span className="income-item-separator">/</span>
                  <span className="income-item-total">
                    {formatNumber(total)}
                  </span>
                </div>
              </div>
              <div className="income-bar-track">
                <div 
                  className={`income-bar-fill income-bar-${item.color}`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IncomeBreakdown;
